import React from 'react';
import RecordNotFound from "../../../Assets/RecordNotFound.png";
import "./NoRecordFound.scss";

const NoRecordFound = () => {

  return (

    <div className="centered-container">
      <img className="specific-img" src={RecordNotFound} alt="No Records Found" />
      <p className="no-record-text">
        No Records found
      </p>
    </div>
  )
}
export default NoRecordFound;
